export default __webpack_public_path__ + "static/media/ionu_popescu.7de3a256.png";